import React from "react";
import { Tooltip } from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import styles from "../funnelChart.module.css";

export function ExcludeEnrolledToggle() {
  const dispatch = useDispatch();
  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  const toggleExcludeEnrolled = useSelector(
    (state) => state.laser.selectedFilters.toggleExcludeEnrolled
  );

  return startFrom == "leads" ? (
    <>
      <Tooltip id="excludeEnrolledTooltip" className={styles.toggleTooltip} />
      <div className="select-box toggle" style={{ width: 250 }}>
        <span
          data-tooltip-id="excludeEnrolledTooltip"
          data-tooltip-content="This toggle will exclude first bookings (appointment and visits/shows) when the prospect or lead has already enrolled/converted. If the first booking date is later than enrollment date, the booking will not count in the Appointment and the Show section."
        >
          <p className="offers-title">Exclude Enrolled Bookings</p>
          <ToggleableButton
            isActive={toggleExcludeEnrolled}
            isRadio
            title="exclude-enrolled-toggle"
            onClick={(checked) => dispatch(actionCreators.toggleExcludeEnrolled(checked))}
          />
        </span>
      </div>
    </>
  ) : null;
}
